import { useLocation } from "react-router";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import { PencilIcon } from "../../shared/icons";
import { usePrivacyDocumentTitle } from "../../shared/usePrivacyDocumentTitle";
import { usePrivacyNavigate } from "../../shared/usePrivacyNavigate";
import { AssistantGreeting } from "./AssistantGreeting";
import { AssistantLayout } from "./AssistantLayout";
import type { AssistantLandingState } from "./navigationState";

export const AssistantLandingPage = () => {
  usePrivacyDocumentTitle("Assistant.Title");
  const { t } = useTranslation();
  const { navigate, paths } = usePrivacyNavigate();
  const state = useLocation().state as AssistantLandingState;

  return (
    <AssistantLayout>
      <AssistantGreeting>
        {state?.conversationMissing && <Typography color="error">{t("Assistant.NotFound")}</Typography>}
        <Button startIcon={<PencilIcon size={14} />} onClick={() => navigate(paths.assistantNew())}>
          {t("Assistant.History.NewChat")}
        </Button>
      </AssistantGreeting>
    </AssistantLayout>
  );
};
